import darkTokens from '@volvo-cars/ui-design-tokens/build/web/volvo-dark/tokens.json';
import lightTokens from '@volvo-cars/ui-design-tokens/build/web/volvo/tokens.json';
import { buildTypeScale } from './buildTypeScale';
import { fonts, isUnsupportedFontLocale } from './fonts';
import { breakpoints } from './getBreakpoints';
import { getTokens } from './getTokens';
import { fontTypes, getTypeScale } from './getTypeScale';

function isRtlLocale(locale) {
  return typeof locale === 'string' && (locale.startsWith('ar') || locale.startsWith('he'));
}

export function getTheme() {
  let {
    variant = 'light',
    locale,
    direction
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const designTokens = variant === 'light' ? lightTokens : darkTokens;
  const tokens = getTokens(designTokens.color, variant);
  const typeScale = getTypeScale(designTokens.color, locale);
  const name = variant === 'light' ? 'volvo' : 'volvo-dark';
  return {
    name,
    direction: direction || (isRtlLocale(locale) ? 'rtl' : 'ltr'),
    baselineGrid: 8,
    baselineSubGrid: 4,
    breakpoints,
    tokens,
    fonts: isUnsupportedFontLocale(locale) ? [] : fonts,
    fontsPath: 'https://www.volvocars.com/static/shared/fonts/',
    fontTypes,
    logoImagesPath: 'https://www.volvocars.com/static/shared/images/',
    iconsPath: 'https://www.volvocars.com/static/shared/icons/v1.1/',
    typeScale: buildTypeScale(typeScale),
    // New Design Tokens
    ...designTokens
  };
}